export default "__VITE_ASSET__b56ce475__"